import { Image, Layout } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { ApiStatusBadge } from '../components/ApiStatusBadge/ApiStatusBadge';
import { DonateContent } from '../components/DonateContent';
import { decryptEmail } from '../util';
import { borderRadiusBase, componentBackground } from '../util/theme';

const { Content } = Layout;

const EndIsNearModesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
`;

export const EndIsNear = () => {
    return (
        <Content>
            <div className="end-is-near-container">
                <EndIsNearModesContainer>
                    <h2>7. 5. 2026 - Aktuální stav</h2>
                    <p>Bezplatné kredity stačí k tomu, aby hry s panoramaty běžely vždy cca prvních 10 dní v měsíci.</p>
                    <p>
                        Občas chodí dotazy a pár z vás posílalo návrhy, jak to provést, aby hra běžela déle, případně
                        zda je možné ji nějak provozovat u sebe. Za současného stavu to bohužel možné není.{' '}
                    </p>
                    <p>
                        Na většinu těchto dotazů a návrhů lze nalézt odpověď v komentářích pod{' '}
                        <a
                            href={
                                'https://www.facebook.com/kdetosakra.cz/posts/pfbid0qzdd4rhPLWk7MUX7HgCcU46F8tAuSypQDwfswwKrVjmEy9h4JY68N7fpSYU8pncel'
                            }
                            target={'_blank'}
                            rel="noopener noreferrer"
                        >
                            tímhle postem
                        </a>{' '}
                        na Facebooku.
                    </p>
                    <p>
                        Pro plný a nepřerušovaný běh by hra potřebovala mecenáše, který by ji podporoval desítkami tisíc
                        měsíčně. Konkrétně by šlo zhruba o 80 až 100 000 Kč měsíčně jen za Mapy.com API, což je částka,
                        za kterou už se dá provozovat leccos, třeba menší e-shop, slušná kancelář, nebo jedna velmi
                        hladová česká zeměpisná hra.
                    </p>
                    <p>
                        Kdyby existoval člověk či firma, kterým přijde jako dobrý nápad sponzorovat cizím lidem toulání
                        po českých panoramatech, osobně mu postavím virtuální pomník a udělám reklamu na webu.
                    </p>
                    <p>
                        Pokud má tedy někdo chuť každý měsíc posílat peníze do kartografické černé díry,{' '}
                        <a href={decryptEmail('amFuLmJvdWNobmVyQGdtYWlsLmNvbQ==')}>napište mi</a> a domluvíme se 🙂.
                    </p>
                    <hr style={{ width: '100%', margin: '30px 0', border: 'none', borderTop: '1px solid #e8e8e8' }} />
                    <h2>29. 12. 2025 - Update: Jedeme dál!</h2>
                    <p>
                        Nakonec se mi podařilo hru přepsat na nové{' '}
                        <a href="https://developer.mapy.com/">Mapy.com REST API</a>, takže KdeToSakra pokračuje dál!
                    </p>
                    <p>
                        Háček je v tom, že máme k dispozici pouze omezený počet bezplatných kreditů měsíčně. Jakmile se
                        vyčerpají, hra se dočasně pozastaví až do dalšího měsíce, kdy se kredity obnoví.
                    </p>
                    <p>
                        Aktuální stav hry poznáte podle indikátoru v pravém dolním rohu na hlavní stránce. Děkuji všem
                        za trpělivost a podporu!
                    </p>
                    <hr style={{ width: '100%', margin: '30px 0', border: 'none', borderTop: '1px solid #e8e8e8' }} />
                    <h2>11. 4. 2024 - Bohužel</h2>
                    <p>
                        Nedávno mě oslovili <a href="https://developer.mapy.cz/">Mapy.cz</a>, díky kterým celý projekt
                        KdeToSakra funguje. Upozornili mě, že jejich stávající{' '}
                        <a href="https://developer.mapy.cz/js-api/">JS SDK</a> (zdroj dat, fotografií a map pro náš web)
                        koncem roku 2025 vypnou a bude nahrazeno novou verzí.
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Image
                            alt="Upozornění na končící podporu"
                            src={`${process.env.REACT_APP_WEB_URL}/mapy.png`}
                            height={150}
                        />
                    </div>
                    <br />
                    <p>
                        Nová verze REST API od Seznamu je <a href="https://developer.mapy.cz/cena/">placená</a> dle
                        počtu stažených panorama dlaždic.
                    </p>
                    <p>
                        Požádal jsem o cenový odhad provozu na novém API, a odpověď mě přivedla k tvrdé realitě:{' '}
                        <b>Náklady by činily zhruba 100 000 Kč měsíčně</b>.
                    </p>
                    <p>
                        KdeToSakra byl a je nevýdělečný hobby projekt, takže si na sebe nevydělá a dotovat ho takovou
                        částkou jednoduše není možné.
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Image
                            alt="Cenový odhad za používání nového REST API Mapy.cz"
                            src={`${process.env.REACT_APP_WEB_URL}/new-api-price.jpg`}
                            height={150}
                        />
                    </div>
                    <br />
                    <h3>Co to znamená?</h3>
                    <p>KdeToSakra přestane na konci roku 2025 fungovat.</p>
                    <p>
                        Chci touto cestou poděkovat společnosti Seznam.cz, že jsme mohli tak dlouhou dobu využívat
                        jejich API zdarma a v takové míře. Z byznysového pohledu jejich rozhodnutí naprosto chápu.
                    </p>
                    <p>
                        A hlavně! – děkuji vám všem, které tento projekt bavil, kteří jste ho hráli, podporovali a
                        šířili. Hrajte, dokud můžete, a užijte si to! 😉
                    </p>
                    <h2>Poděkovat</h2>
                    <p>
                        Nechávám za sebou provoz a vyšší desítky, spíš nižší stovky hodin práce pro bono 🙂. Pokud mně
                        chcete podpořit v mých dalších budoucích aktivitách nebo poděkovat nad rámec, můžete mi zaslat
                        příspěvek.
                    </p>
                    <DonateContent marginBottom={15} />
                    <p>
                        Díky za společné zážitky,{' '}
                        <a href={decryptEmail('amFuLmJvdWNobmVyQGdtYWlsLmNvbQ==')}>Honza Bouchner</a>
                    </p>
                </EndIsNearModesContainer>
            </div>
            <ApiStatusBadge />
        </Content>
    );
};
